// polyfills
import picturefill from 'picturefill';
// import objectFitPolyfill from 'objectFitPolyfill';

// pages & components
import lazy from './scripts/lazyload';
import carousel from './scripts/carousel';
import navigation from './scripts/navigation';
import product from './scripts/product';
import addToCart from './scripts/add-to-cart';

class App {
  constructor() {
    lazy.init();
    
    // carousels
    carousel.init();

    // navigation
    navigation.init();

    // add to cart
    addToCart.init();

    // product page
    product.init();

    // polyfills
    // 'srcset' and <picture>
    picturefill();
    // object-fit
    // objectFitPolyfill();
  }
}

const app = new App();